import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';

export function PitstopButton(props) {
  const { type = 'primary', children, ...otherProps } = props;

  let buttonType = type;

  switch (type) {
    case 'primary':
    case 'secondary':
    case 'tertiary':
    case 'dashed':
      break;
    default:
      buttonType = 'primary';
      break;
  }

  return (
    <Button {...otherProps} type={buttonType}>
      {children}
    </Button>
  );
}

PitstopButton.propTypes = {
  type: PropTypes.string.isRequired,
  children: PropTypes.node,
};

PitstopButton.defaultProps = {
  type: 'primary',
};
